export enum WriteOffStatus {
    WriteOff = 'write-off',
    WriteBack = 'write-back'
}

export enum WriteOffTag {
    SubStandardAsset = 'sub-standard-asset',
    LossAsset = 'loss-asset',
    Settlement = 'settlement',
    LoanRestructure = 'loan-restructure'
}

export class WriteOffHistory {
    public readonly principal: number;
    public readonly interest: number;
    public readonly status: WriteOffStatus;
    public readonly tag: WriteOffTag;
    public createdAt: Date;

    constructor(principal: number, interest: number, status: WriteOffStatus, tag: WriteOffTag, createdAt: Date) {
        this.principal = principal;
        this.interest = interest;
        this.status = status;
        this.tag = tag;
        this.createdAt = createdAt;
    }
}

export class WriteOff {
    public _id: string;
    public readonly loanId: string;
    public readonly principal: number;
    public readonly interest: number;
    public history: WriteOffHistory[];
    public readonly createdAt: Date;

    constructor(loanId: string, principal: number, interest: number, history: WriteOffHistory[], createdAt: Date) {
        this.loanId = loanId;
        this.principal = principal;
        this.interest = interest;
        this.history = history;
        this.createdAt = createdAt;
    }
}
